// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.se-wrapper > div.se-wrapper-inner.se-wrapper-wysiwyg.sun-editor-editable.ps.ps--active-y > div.ps__rail-y.ps--clicking
{
    top: 0px !important;
}

.se-toolbar.sun-editor-common {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
  background: #f5f5f5 !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/RichTextEditor/fixscroll.css"],"names":[],"mappings":"AAAA;;IAEI,mBAAmB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,8BAA8B;AAChC","sourcesContent":["div.se-wrapper > div.se-wrapper-inner.se-wrapper-wysiwyg.sun-editor-editable.ps.ps--active-y > div.ps__rail-y.ps--clicking\n{\n    top: 0px !important;\n}\n\n.se-toolbar.sun-editor-common {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1000 !important;\n  background: #f5f5f5 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
